import React from 'react';
import { connect } from 'react-redux';
import PageTitleBar from '../Layouts/PageTitleBar';
import Tablero from './Tablero/Tablero';
import { mostrarFormulario } from '../Helpers/HelperNavegacion';

function Contenidos({ navegadoresStore, componenteActivoID, openMenu, relacionLaboral, modulosApi }) {

    const show = { display: 'block', minHeight: '69vh'};
    const hide = { display: 'none' };

    return (
        <React.Fragment>
            <style>
                {
                    (openMenu)
                    ?
                    `.styles_overlay__CLSq- {
                            background: rgba(0, 0, 0, 0.2);
                            padding-left: 264px;
                            transition: padding-left 0.2s ease-in-out;
                            -webkit-transition: padding-left 0.2s  ease-out;
                            -moz-transition: padding-left 0.2s  ease-out;
                            -o-transition: padding-left 0.2s  ease-out;
                        }`
                    :
                    `.styles_overlay__CLSq- {
                            background: rgba(0, 0, 0, 0.2);
                            padding-left: 24px;
                            transition: padding-left 0.2s ease-in-out;
                            -webkit-transition: padding-left 0.2s  ease-out;
                            -moz-transition: padding-left 0.2s  ease-out;
                            -o-transition: padding-left 0.2s  ease-out;
                        }`
                }
            </style>
            <div style={ componenteActivoID === 1 ? show : hide }>
                { modulosApi.length > 0 && <Tablero relacionLaboral={relacionLaboral} modulosApi={modulosApi}/> }
            </div>
            { Object.keys(navegadoresStore).map(key => {                
                if( componenteActivoID === navegadoresStore[key].id ){
                    var contenido = document.getElementById( `Contenido${navegadoresStore[key].nombre}` );
                    if( contenido ){
                        if( contenido.getElementsByClassName( 'styles_overlay__CLSq-' ).length === 0 ){
                            document.getElementById( 'html' ).style['position'] = "";
                            document.getElementById( 'html' ).style['overflow'] = "";
                        }else{
                            document.getElementById( 'html' ).style['position'] = "fixed";
                            document.getElementById( 'html' ).style['overflow'] = "hidden";
                        }
                    }
                }
                return(
                    <div key={navegadoresStore[key].nombre} id={`Contenido${navegadoresStore[key].nombre}`} style={ componenteActivoID === navegadoresStore[key].id ? show : hide }>
                        <div style={{ position: "relative", zIndex: "100" }}>
                            <PageTitleBar title={navegadoresStore[key].nombre} path={navegadoresStore[key].ruta}/>
                            { mostrarFormulario( navegadoresStore[key].id, navegadoresStore[key].permisos )}
                        </div>
                    </div>
                )
            })}
        </React.Fragment>
    );
}

/* ------------------------------------------------------------------------------------------------------------------  */
const mapStateToProps = (state) => ({
    navegadoresStore : state.NavReducer.navegadores,
    componenteActivoID: state.NavReducer.componenteActivo
});
const mapDispatchToProps = {};
/* ------------------------------------------------------------------------------------------------------------------  */
export default connect(mapStateToProps, mapDispatchToProps)(Contenidos);

